"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ion_range_slider_component_1 = require("./ion-range-slider.component");
var core_1 = require("@angular/core");
var IonRangeSliderModule = (function () {
    function IonRangeSliderModule() {
    }
    return IonRangeSliderModule;
}());
IonRangeSliderModule = __decorate([
    core_1.NgModule({
        exports: [ion_range_slider_component_1.IonRangeSliderComponent],
        declarations: [ion_range_slider_component_1.IonRangeSliderComponent]
    })
], IonRangeSliderModule);
exports.IonRangeSliderModule = IonRangeSliderModule;
//# sourceMappingURL=ion-range-slider.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-ion-range-slider/lib/ion-range-slider.module.js
// module id = 1543
// module chunks = 21